import React from 'react';
import './Navigation.css';

const Navigation = ({ activeSection }) => {
  const navItems = [
    { id: 'home', label: 'Home' },
    //{ id: 'about', label: 'About Me' },
    { id: 'works', label: 'Projects' },
    { id: 'contributions', label: 'Contributions' },
    { id: 'contact', label: 'Contact' }
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className="navigation">
      <div className="nav-container">
        <div className="nav-brand">xeerp</div>
        <ul className="nav-menu">
          {console.log(navItems)}
          {navItems.map((item) => (
            <li key={item.id}>
              <button
                className={`nav-link ${activeSection === item.id ? 'active' : ''}`}
                onClick={() => scrollToSection(item.id)}
              >
                {item.label}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;